// stores/translations.js
import { defineStore } from 'pinia'

export const useTranslationStore = defineStore('translations', {
    
  state: () => ({
    translations: {},
    isLoaded: false
  }),

  actions: {
    async fetchTranslations() {
      // Several components call this independently (unawaited callOnce/onMounted);
      // once loaded, later calls are no-ops so a failed/empty response can't
      // stomp already-loaded data.
      if (this.isLoaded) return

      const { locale } = useI18n()
      const { baseApi } = useApiBase()
      const apiUrl = `${baseApi}/${locale.value}/translations` // cms
      // const apiUrl = `${config.public.appApi}/${locale.value}/translations` // template

      try {
        const response = await $fetch(apiUrl)
        if (response) {
          this.translations = response
          this.isLoaded = true
        } else {
          console.error('Error fetching translations: empty response')
        }
      } catch (err) {
        console.error('Failed to fetch translations:', err)
      }
    },

    translate(key) {
      const text = (this.translations || {})[key] || key

      // ตรวจสอบว่าเป็น email หรือไม่
      if (key.includes('email.detail')) {
        return `<a href="mailto:${text}">${text}</a>`
      }

      return text
    }
  }
})